export default __webpack_public_path__ + "static/media/klown.b5601fc7.svg";